var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mx-auto",attrs:{"elevation":"0","max-width":"500"}},[_c('v-slide-group',{staticClass:"pa-4",attrs:{"show-arrows":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.thems[_vm.type]),function(color,i){return _c('v-slide-item',{key:i,scopedSlots:_vm._u([{key:"default",fn:function({ active, toggle }){return [_c('ul',{style:({
          width: '130px',
          height: '200px',
          borderRadius: '10px',
          margin: '0',
          padding: '0',
          margin: '1rem',
          cursor: 'pointer',
          position: 'relative',
        }),on:{"click":toggle}},[_c('li',{style:({
            listStyle: 'none',
            width: '100%',
            height: '40%',
            background: color.backgroundColor,
            borderTopLeftRadius: '50px',
          })}),_c('li',{style:({
            listStyle: 'none',
            width: '100%',
            height: '30%',
            background: color.componentsColor,
          })}),_c('li',{style:({
            listStyle: 'none',
            width: '100%',
            height: '20%',
            background: color.iconColor,
          })}),_c('li',{style:({
            listStyle: 'none',
            width: '100%',
            height: '10%',
            background: color.textColor,
            borderBottomRightRadius: '50px',
          })}),_c('li',{style:({
            listStyle: 'none',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            background: '#ffffff4d',
            display: active ? 'flex' : 'none',
            justifyContent: 'center',
            borderBottomRightRadius: '50px',
            borderTopLeftRadius: '50px',
          })},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-check-circle-outline")])],1)])]}}],null,true)})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }